var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-lc",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#65cfff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m318.9 42 162.7 395.3-322.6.9L318.9 42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319 96.5 140.8 340-279 .8L319 96.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "m318.9 240.1 162.7 197.6-322.6.5 159.9-198.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLc);
export default __webpack_public_path__ + "static/media/lc.26619234.svg";
export { ForwardRef as ReactComponent };